// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"96c2b41e","978":"f6e48004","1414":"b9cf6075","2266":"dbca0645","3300":"e001c918","3463":"cd12957d","3703":"a2b52803","4553":"9fee029a"}[chunkId] + ".chunk.css";
};